import React from "react"
import { Flex } from "@chakra-ui/react"
import Icon from "components/elements/Icon"
import type { KioskScanLayout } from "../kioskLayout"

type Props = {
  layout: KioskScanLayout["camera"]
}

/**
 * Dark stand-in for the live camera / QR frame, with a four-corner target reticle centered
 * over it. Size + aspect ratio come from the spec layout (px).
 */
const KioskPreviewScanCameraPlaceholder = ({ layout }: Props) => (
  <Flex
    w={`${layout.width}px`}
    h={`${layout.height}px`}
    borderRadius={`${layout.radius}px`}
    borderWidth="1px"
    borderColor="#48484A"
    bg="gray.900"
    overflow="hidden"
    align="center"
    justify="center"
    flexShrink={0}
  >
    <Icon
      icon="qr-target"
      size={layout.targetSize / 4}
      color="white"
      aria-hidden
    />
  </Flex>
)

export default KioskPreviewScanCameraPlaceholder
